function SectionShell({ children, className = '', dark = false, id }) {
  return (
    <section
      id={id}
      className={`scroll-mt-24 ${dark ? 'bg-[rgb(16_185_129)] text-white sm:px-8 lg:px-12 px-6' : 'text-[#0b1020]'} mx-auto sm:max-w-[80%] max-w-[90%] w-full  py-16  lg:py-16 ${className}`}
    >
      <div>
        {children}
      </div>
    </section>
  );
}

export default SectionShell;
